export const getInitAllocateShippingUnitParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
  };
};

export const allocateShippingUnitMode = {
  CREATE_ALLOCATE_SHIPPING_UNIT_MODE: "CREATE_ALLOCATE_SHIPPING_UNIT_MODE",
  UPDATE_ALLOCATE_SHIPPING_UNIT_MODE: "UPDATE_ALLOCATE_SHIPPING_UNIT_MODE",
};

export const allocateShippingRecordStatus = [
  { key: "O", badgeColor: "success" },
  { key: "C", badgeColor: "danger" },
];

export const allocateShippingRecordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};

export const numberWithCommas = (nStr, isShow) => {
  if (nStr) {
    let dau = "";
    if (isShow) {
      dau = nStr > 0 ? "+" : "";
    }
    nStr += "";
    const x = nStr.split(".");
    let x1 = x[0];
    const x2 = x.length > 1 ? "." + x[1] : "";
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "." + "$2");
    }
    return dau + x1 + x2;
  }
  return "";
};
